import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { FeatureFlagRoute, Layout } from "components";
import { DOCUMENTS_ROUTER, DOCUMENT_UPLOAD_PAGE } from "./documents";
import { DocumentsRouter } from "./documents/router";
import { EMISSION_FACTORS_PAGEINDEX } from "./emission-factors";
import { SETTINGS_ROUTER, SettingsRouterV2 } from "./settingsv2";
import { SITES_EMISSIONS_PAGE, SitesEmissionsPage } from "./sites-emissions";
import { ResourcesRouter } from "./emission-factors/router";
import { SITES_PAGE, SitesPageV2, SiteDetailPage } from "./sitesv2";
import { RecUpload } from "./sitesv2/rec/rec-upload";
import { AUDIT_LOGS_PAGE, AuditLogsPage } from "./audit-logs";
import { RecDetailPage } from "./sitesv2/rec/rec-detail-page";
import { EmissionFactorDetailPage, UtilitySpecificEmissionsFactors } from "./sitesv2/components/site-editor-form/utility-providers/utility-specific-emissions-factors";
import { RenewableEnergyPurchasesUpload } from "./sitesv2/rep/renwable-energy-purchases-upload-page";
import { ApprovalPage, APPROVALS } from "./approvals";
import { DashboardPageV2 } from "./dashboardv2";
import { SCORECARD_PAGE, ScorecardPage } from "./scorecard";
import { JobsPage } from "./jobs";
import { InitiativeDetailPage, /* INITIATIVES_MODELING_PAGE, */ INITIATIVES_PAGE, /* InitiativesModelingPage, */ InitiativesPage, TARGETS_PAGE, TargetsPage } from "./accelerate";

export const AuthenticatedRouter = () => (
  <Layout>
    <Routes>
      <Route path={DOCUMENTS_ROUTER.PATH} element={<DocumentsRouter />} />
      <Route
        path={EMISSION_FACTORS_PAGEINDEX.PATH}
        element={<ResourcesRouter />}
      />
      <Route
        path={SITES_EMISSIONS_PAGE.ABSOLUTE_PATH}
        element={<SitesEmissionsPage />}
      />
      <Route path={SITES_PAGE.ABSOLUTE_PATH} element={<SitesPageV2 />} />
      <Route path='sites/renewable-energy-purchases-upload' element={<RenewableEnergyPurchasesUpload />} />
      <Route path='sites/site-details/:siteId' element={<SiteDetailPage />} />
      <Route path={AUDIT_LOGS_PAGE.ABSOLUTE_PATH} element={<AuditLogsPage />} />
      <Route path='jobs' element={<JobsPage />} />
      <Route path='rec/:collectorId' element={<RecUpload />} />
      <Route path='recDetail/:recId' element={<RecDetailPage />} />
      <Route path='utility-specific-emissions-factors/:collectorId' element={<UtilitySpecificEmissionsFactors />} />
      <Route path='utility-specific-emissions-factors-details/:collectorId/:emissionFactorId' element={<EmissionFactorDetailPage />} />
      <Route path={SCORECARD_PAGE.ABSOLUTE_PATH} element={<ScorecardPage />} />
      <Route path={SETTINGS_ROUTER.PATH} element={<SettingsRouterV2 />} />
      <Route path={SCORECARD_PAGE.ABSOLUTE_PATH} element={<ScorecardPage />} />
      <Route path="/dashboard" element={<DashboardPageV2 />} />
      <Route
        path="*"
        element={<Navigate to={DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH} />}
      />
      <Route path={APPROVALS.ABSOLUTE_PATH} element={<ApprovalPage />} />
      <Route
        path={TARGETS_PAGE.ABSOLUTE_PATH}
        element={
          <FeatureFlagRoute
            featureFlag="target_setting_feature"
            redirectTo={DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH}
          >
            <TargetsPage />
          </FeatureFlagRoute>
        }
      />
      <Route
        path={INITIATIVES_PAGE.ABSOLUTE_PATH}
        element={
          <FeatureFlagRoute
            featureFlag="initiative_managament_feature"
            redirectTo={DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH}
          >
            <InitiativesPage />
          </FeatureFlagRoute>
        }
      />
      <Route
        path={`${INITIATIVES_PAGE.ABSOLUTE_PATH}/:id`}
        element={
          <FeatureFlagRoute
            featureFlag="initiative_managament_feature"
            redirectTo={DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH}
          >
            <InitiativeDetailPage />
          </FeatureFlagRoute>
        }
      />
      {/* <Route
        path={INITIATIVES_MODELING_PAGE.ABSOLUTE_PATH}
        element={
          <FeatureFlagRoute
            featureFlag="initiative_modeling_feature"
            redirectTo={DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH}
          >
            <InitiativesModelingPage />
          </FeatureFlagRoute>
        }
      /> */}
    </Routes>
  </Layout>
);
